jQuery( function ( $ ) {

  $( '.term-nav' ).each( function () {
    const $wrap = $(this);
    const $btn = $( '.toggle-term-nav', $wrap );
    const $menu = $( '.term-nav-list', $wrap );

    function is_open () {
      return $menu.attr( 'aria-hidden' ) == 'false';
    }

    function set_open ( input ) {
      const open = Boolean( input );
      $btn.toggleClass( 'open', open );
      $menu.attr( 'aria-hidden', ( open ? 'false' : 'true' ) );
    }

    $btn.on( 'click', function () {
      set_open( !is_open() );
    });

    $wrap.on( 'focusout', function ( e ) {
      if ( !$.contains( this, e.relatedTarget ) ) {
        set_open( false );
      }
    });

    $(document).on( 'click', function ( e ) {
      if ( !$.contains( $wrap.get(0), e.target ) ) {
        set_open( false );
      }
    });

  });

});